<template>
  <div>
    <titulo-modulo titulo="Minha Conta" />
    <v-card flat class="mt-3">
      <v-card-text>
        <v-tabs
          :vertical="!isMobile()"
          :show-arrows="isMobile()"
          v-model="tabContaModel"
        >
          <v-tab>Alterar senha</v-tab>
          <v-tab>Configurar e-mail</v-tab>
          <v-tab-item>
            <alterar-senha />
          </v-tab-item>
          <v-tab-item>
            <config-email />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import AlterarSenha from "../minha-conta/alterar-senha/AlterarSenha.vue";
import ConfigEmail from "./config-email/ConfigEmail.vue";
export default {
  components: { TituloModulo, AlterarSenha, ConfigEmail },
  computed: {
    ...mapState("usuario", ["tabConta"]),
    tabContaModel: {
      get: function () {
        return this.tabConta;
      },
      set: function (value) {
        this.setTabConta(value);
      },
    },
  },
  methods: {
    ...mapMutations("usuario", ["setTabConta"]),
    getHeight() {
      return screen.availHeight - 300;
    },
    isMobile() {
      return this.$mq === "sm";
    },
  },
};
</script>

<style>
</style>